import React, { Component } from "react";
import { CardTypeThree } from "components/Common/Cards";
import { Row, Col, Label, Button } from "reactstrap";
import { commonSummaryStyle } from "components/Common/Summary/styles/CommonSummaryStyle.js";
import { plusCircle } from "react-icons-kit/fa/plusCircle";
import { withPlus } from "react-icons-kit/entypo/withPlus";
import SvgIcon from "react-icons-kit";
import { ButtonCirclePlus } from "components/Common/Buttons";
import { Tooltip } from "reactstrap";
//import { ic_expand_more } from "react-icons-kit/md/ic_expand_more";
import { Icon } from "react-icons-kit";
import { checkmark } from "react-icons-kit/icomoon/checkmark";
import { summeryStyle } from "style/components/Summary/commonSummary";
import { themeService } from "../../../theme/service/activeTheme.service";
import { getStatusColor } from "../../../utils/statusColors";
import propTypes from "prop-types";
/*
summaryDesc: { first: 'First Summary Card Text', second: 'Second Summary Card Text', third: 'Third Summary Card Text', fourth: 'Fourth Summary Card Text' , fifth : 'Fifth Summary Card Text ', sixth : 'sixth Summary Card Text' },
summaryValue: { first: 0, second: 0, third: 0, fourth: 0  , fifth: 0, sixth : 0}

*/
import { languageService } from "../../../Language/language.service";
import { versionInfo } from "../../MainPage/VersionInfo";

class CommonSummary extends Component {
  constructor(props) {
    super(props);
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.state = {
      tooltipOpen: false,
      valueRotate: 0,
    };
    this.RoatetIcon = this.RoatetIcon.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }
  RoatetIcon() {
    this.props.handleHideShow();
    this.setState({ valueRotate: this.state.valueRotate + 180 });
  }

  isSelected(cardKey) {
    // Only check selection if showSelectionIndicator is enabled
    if (!this.props.showSelectionIndicator) {
      return false;
    }
    if (!this.props.summaryLabels) {
      return false;
    }

    if (!this.props.selectedSummaries || this.props.selectedSummaries.length === 0) {
      return cardKey === "first";
    }
    const cardLabel = this.props.summaryLabels[cardKey];
    return this.props.selectedSummaries.includes(cardLabel);
  }

  renderTickMark() {
    if (!this.props.showSelectionIndicator) {
      return null;
    }
    return (
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: 15,
          backgroundColor: "var(--first)",
          opacity: "0.8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon icon={checkmark} size={12} style={{ color: "#000000" }} />
      </div>
    );
  }

  render() {
    let summaryDesc = this.props.descriptions ? this.props.descriptions : {};
    let summaryVals = this.props.values ? this.props.values : {};
    let assigned = this.props.assignedToMe ? this.props.assignedToMe : {};
    let permissoinValue = true;

    if (this.props.permissionCheckProps) {
      permissoinValue = this.props.permissionCheck;
    }
    return (
      <div>
        <div style={themeService(commonSummaryStyle.summaryContainer(this.props))}>
          <Row style={themeService(commonSummaryStyle.summaryMainStyle(this.props))}>
            <Col md="11">
              <Row style={themeService(commonSummaryStyle.allCardSummaryContainer)}>
                {summaryDesc.first && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("first")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.first}
                        numberColor={getStatusColor(this.props.summaryLabels.first)}
                        topRight={assigned.first}
                        text={summaryDesc.first}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("first") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
                {summaryDesc.second && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("second")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.second}
                        numberColor={getStatusColor(this.props.summaryLabels.second)}
                        topRight={assigned.second}
                        text={summaryDesc.second}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("second") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
                {summaryDesc.third && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("third")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.third}
                        numberColor={getStatusColor(this.props.summaryLabels.third)}
                        topRight={assigned.third}
                        text={summaryDesc.third}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("third") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
                {summaryDesc.fourth && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("fourth")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.fourth}
                        numberColor={getStatusColor(this.props.summaryLabels.fourth)}
                        topRight={assigned.fourth}
                        text={summaryDesc.fourth}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("fourth") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
                {summaryDesc.fifth && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("fifth")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.fifth}
                        numberColor={getStatusColor(this.props.summaryLabels.fifth)}
                        topRight={assigned.fifth}
                        text={summaryDesc.fifth}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("fifth") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
                {summaryDesc.sixth && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("sixth")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.sixth}
                        numberColor={getStatusColor(this.props.summaryLabels.sixth)}
                        topRight={assigned.sixth}
                        text={summaryDesc.sixth}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("sixth") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
                {summaryDesc.seventh && (
                  <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                    <div onClick={() => this.props.handleSummaryClick("seventh")} style={{ cursor: "pointer", position: "relative" }}>
                      <CardTypeThree
                        number={summaryVals.seventh}
                        numberColor={getStatusColor(this.props.summaryLabels.seventh)}
                        topRight={assigned.seventh}
                        text={summaryDesc.seventh}
                        styles={{ cursor: "pointer" }}
                      />
                      {this.isSelected("seventh") && this.renderTickMark()}
                    </div>
                  </Col>
                )}
              </Row>
              {!versionInfo.isReVAMP() &&
                (summaryDesc.stateOpen || summaryDesc.stateClosed || summaryDesc.stateReview || summaryDesc.stateReturned) && (
                  <Row style={themeService(commonSummaryStyle.allCardSummaryContainer)}>
                    {summaryDesc.stateOpen && (
                      <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                        <div onClick={() => this.props.handleSummaryClick("stateOpen")} style={{ cursor: "pointer", position: "relative" }}>
                          <CardTypeThree
                            number={summaryVals.stateOpen}
                            numberColor={getStatusColor(this.props.summaryLabels.stateOpen)}
                            topRight={assigned.stateOpen}
                            text={summaryDesc.stateOpen}
                            styles={{ cursor: "pointer" }}
                          />
                          {this.isSelected("stateOpen") && this.renderTickMark()}
                        </div>
                      </Col>
                    )}
                    {summaryDesc.stateReview && (
                      <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                        <div
                          onClick={() => this.props.handleSummaryClick("stateReview")}
                          style={{ cursor: "pointer", position: "relative" }}
                        >
                          <CardTypeThree
                            number={summaryVals.stateReview}
                            numberColor={getStatusColor(this.props.summaryLabels.stateReview)}
                            topRight={assigned.stateReview}
                            text={summaryDesc.stateReview}
                            styles={{ cursor: "pointer" }}
                          />
                          {this.isSelected("stateReview") && this.renderTickMark()}
                        </div>
                      </Col>
                    )}
                    {summaryDesc.stateReturned && (
                      <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                        <div
                          onClick={() => this.props.handleSummaryClick("stateReturned")}
                          style={{ cursor: "pointer", position: "relative" }}
                        >
                          <CardTypeThree
                            number={summaryVals.stateReturned}
                            numberColor={getStatusColor(this.props.summaryLabels.stateReturned)}
                            topRight={assigned.stateReturned}
                            text={summaryDesc.stateReturned}
                            styles={{ cursor: "pointer" }}
                          />
                          {this.isSelected("stateReturned") && this.renderTickMark()}
                        </div>
                      </Col>
                    )}
                    {summaryDesc.stateClosed && (
                      <Col lg="2" md="3" sm="4" style={themeService(commonSummaryStyle.cardContainer)}>
                        <div
                          onClick={() => this.props.handleSummaryClick("stateClosed")}
                          style={{ cursor: "pointer", position: "relative" }}
                        >
                          <CardTypeThree
                            number={summaryVals.stateClosed}
                            numberColor={getStatusColor(this.props.summaryLabels.stateClosed)}
                            topRight={assigned.stateClosed}
                            text={summaryDesc.stateClosed}
                            styles={{ cursor: "pointer" }}
                          />
                          {this.isSelected("stateClosed") && this.renderTickMark()}
                        </div>
                      </Col>
                    )}
                  </Row>
                )}
            </Col>
            {this.props.AddButton && (
              <Col md="1">
                {permissoinValue && (
                  <div>
                    <div id={"toolTipAdd" + this.props.addToolTipId}>
                      <ButtonCirclePlus
                        handleClick={(e) => {
                          this.props.handleAddNewClick("Add");
                        }}
                        {...themeService(commonSummaryStyle.addButtonStyle(this.props))}
                      />
                    </div>

                    <Tooltip isOpen={this.state.tooltipOpen} target={"toolTipAdd" + this.props.addToolTipId} toggle={this.toggleTooltip}>
                      {languageService("Add")} {languageService(this.props.addTootTipText)}
                    </Tooltip>
                  </div>
                )}
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  }
}

export default CommonSummary;

CommonSummary.defaultProps = {
  summaryLabels: {},
  showSelectionIndicator: false, // Opt-in prop to enable selection indicator
};



// WEBPACK FOOTER //
// ./src/components/Common/Summary/CommonSummary.js